import gql from 'graphql-tag';
import compose from 'lodash/flowRight';
import { graphql } from 'react-apollo';
import {
  AppointmentFormInfoOpeningFragment,
  AppointmentFormInfoProviderFragment,
} from './AppointmentFormInfo';

// We need to make a separate query for the provider because we rely on the provider id to generate
// the opening id. If the `providerId` param is actually the slug, this fails. Once we migrate
// to linking directly to opening ids rather than the opening timestamp slug, these queries can be
// combined.
export const PROVIDER_DATA_QUERY = gql`
  query AppointmentFormPageProviderData($providerId: ID!) {
    provider(id: $providerId) {
      id
      slug
      display
      upfrontInsuranceCollectionEnabled
      onlineSchedulingEnabled
      profile {
        id
        agesTreated {
          min
          max
          display
        }
      }
      office {
        id
        display
        countryCode
        insuranceCoverageEnabled
      }
      practice {
        id
        display
      }
      ...${AppointmentFormInfoProviderFragment.name}
    }
  }
  ${AppointmentFormInfoProviderFragment.query}
`;

export const addProviderData = graphql(PROVIDER_DATA_QUERY, {
  name: 'providerData',
  alias: 'withProviderData',
  options({ match: { params } }) {
    return { variables: { providerId: params.providerId } };
  },
});

export const OPENING_DATA_QUERY = gql`
  query AppointmentFormPageOpeningData($openingId: ID!) {
    currentUser {
      id
      username
      display
      givenName
      familyName
      roles
      patient {
        id
        display
        birthDate
        email
        mobilePhone
        dependents(perPage: 100) {
          nodes {
            id
            display
            birthDate
          }
        }
      }
    }
    opening(id: $openingId) {
      id
      pendingUntil
      reasonsForVisit(perPage: 100) {
        nodes {
          id
          display: name
          patientStatus
          description
        }
      }
      ...${AppointmentFormInfoOpeningFragment.name}
    }
  }
  ${AppointmentFormInfoOpeningFragment.query}
`;

export const addOpeningData = graphql(OPENING_DATA_QUERY, {
  name: 'openingData',
  alias: 'withOpeningData',
  skip: ({ providerData }) => providerData == null || providerData.provider == null,
  options({ match: { params }, providerData }) {
    // TODO: use full opening IDs in appointment form URLs.
    const { openingSlug } = params;
    const openingId = `${providerData.provider.id}_${openingSlug.replace('-', '_')}`;
    return { variables: { openingId } };
  },
});

const addAppointmentFormPageData = compose(addProviderData, addOpeningData);

export default addAppointmentFormPageData;
